<template>
  <body class="home">
  <el-container class="home">
    <el-main>
      <div class="el_col">
        <img src="../assets/tab_img.png" alt="logo" class="img_title">
        <div class="el_row">
          <RowScollView/>
        </div>

        <div class="el_col" style="align-items: flex-start;width: 70%;margin-top: 20px">
          <img src="../assets/step.gif" style="width: 300px" alt="输入手机号">
        </div>
        <el-input class="el_phone_input" type="number" maxlength="11"
                  v-model="phone"
                  :placeholder="input_phone_hinder"
                  :pattern="pone_pattern"
        />
        <!--        <div class="el_row">-->
        <!--          <el-input class="el_code_input" type="number" maxlength="4"-->
        <!--                    v-model="code"-->
        <!--                    :placeholder="input_code_hinder"-->
        <!--                    :pattern="code_pattern"-->
        <!--          />-->
        <!--          <CodeView :phone="phone"/>-->
        <!--        </div>-->

        <img src="../assets/get.png" @click="getGo()" class="img">

        <div class="el_row" style="text-align: left;width: 80%">
          <!--          <input type="checkbox" :value="checked" :checked="checked" @onclick="handleCheckChanged"/>-->
          <el-checkbox @change="handleCheckChanged" v-model="checked" size="large"/>
          <p style="margin-left: 10px;color: white"> 我已阅读并同意<span
            @click="readInfo()">《服务协议》</span>及<span
            @click="readInfo()">《隐私政策》</span>，知悉业务说明并用该号码登录办理
          </p>
        </div>

        <div class="el_row">
          <p class="font_size">
            开通咪咕悦看超级会员,<strong>标准资费20元/月</strong>，
            以<strong>话费支付</strong>，具体以实际扣费为准，
            支付成功后<strong>立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。</strong>
            可随时取消，取消<strong>立即生效</strong>,当前周期内可继续享受权益，次月起不再扣费。
          </p>
        </div>

        <strong style="font-size: 20px;text-align: center;color:white">客服热线：4009685118</strong>
        <img src="../assets/ad.png" alt="logo" class="img_title">
        <img src="../assets/ad1.png" alt="logo" style="margin-top: 20px" class="img_title">
        <p style="color: white;font-size: 20px;">业务规则</p>
        <div class="el_col"
             style="color: white;font-size: 18px;align-items: flex-start;text-align: left;">
          <p style="margin-left: 20px;margin-right: 20px">1、产品名称：咪咕悦看超级会员。<br/>
            2、产品资费：<strong>话费</strong>支付<strong>20元/月</strong><br/>
            3、产品对象：<strong>中国移动用户（不含港澳台用户）</strong>。<br/>
            4、生效时间：支付成功后<strong>立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。</strong>，
            可随时取消，取消<strong>立即生效</strong>，当前周期内可继续享受权益，次月起不再扣费。
            <br/>
            5、产品内容： <strong>咪咕悦看超级会员</strong>可享咪咕悦看APP内海量短剧畅看（特殊版权内容除外）、海量图书畅读（特殊版权内容除外）等权益。更详细权益介绍可至咪咕悦看APP会员界面查看。<br>

            6、权益领取：<strong>咪咕悦看超级会员权益</strong>订购成功后，权益无需客户领取，立即直充到账，请<strong>下载咪咕悦看</strong>APP，用订购手机号码登录后，点击下方短剧导航-选择会员，即可观看喜欢的短剧。<br>


            7、<strong>同一连续包月产品，每个用户每月仅能订购一次。</strong>咪咕短剧精品会员系列，产品权益可同时生效，短剧任选次数可叠加；咪咕悦看超级会员和咪咕短剧标准会员的连续及非连续包，可同类型及互相间叠加有效期，叠加后优先使用咪咕悦看超级会员权益，其次是咪咕短剧标准会员，无法和任何其他会员类型包叠加；在购买咪咕悦看超级会员后，如果账号内仍有未过期的咪咕短剧标准会员，将会优先生效咪咕悦看超级会员权益，剩余的咪咕短剧标准会员到期时间将顺延，待咪咕悦看超级会员过期时继续生效咪咕短剧标准会员。<br>


            8、办理须知：订购业务前请仔细阅读活动规则，订购本业务，即视为同意接受本业务及其相关活动的所有条款或规则。<br/>
            9、<strong>退订方式：所属省份 10086 热线、当地中国移动营业厅、中国移动 APP。</strong><br/>
            10、如发生不可抗力、情势变更情形（包括但不限于因自然灾害、司法行政命令、公共服务故障、设备与系统维护或故障、网络信息与数据安全、外呼电话无法联系用户等）造成您订购、兑换、使用或变更相关权益障碍、延后或内容变更等情形，我们可依据法律法规的规定主张免责、采取适当应对措施。<br/>
            11、客服咨询：<br/>
            ①客服热线：4009685118，客服工作时间：周一到周日8:00-21:00，节假日无休<br/>
            ②在线客服：咪咕悦看APP-我的-帮助与客服-联系人工，工作时间：周一到周日08:30-22:00，节假日无休。 </p>
        </div>
      </div>

    </el-main>

    <el-dialog
      v-model="centerDialogVisible"
      width="500"
      align-center
    >
      <div style="width: 100%;text-align:left;font-size: 20px ">
        <p>尊敬的客户：</p>
        <p>根据《中华人民共和国反恐怖主义法》、
          《全国人民代表大会常务委员会关于加强网络信息保护的决定》、
          《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）等国家法律法规的要求，
          为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。</p>
        <p> 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、
          保障通信服务安全、改善服务质量、推介个性化产品等，
          我公司将遵循合法、正当、必要的原则，
          按照法律法规规定或协议约定使用留存客户个人信息，
          并妥善保管，严格保密，依法保护客户个人信息。</p>
      </div>
    </el-dialog>

    <CustomDialog v-if="showToast" :close="handColse"/>

  </el-container>
  </body>

</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import CodeView from '@/components/CodeView.vue'
import RowScollView from '@/components/RowScollView.vue'
import { post } from '@/api/phone'
import { ElLoading } from 'element-plus'
import CustomDialog from '../components/CustomDialogComponent.vue'

@Options({
  components: {
    CodeView,
    RowScollView,
    CustomDialog
  },
  data () {
    return {
      input_phone_hinder: '请输入手机号',
      pone_pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
      code_pattern: /^[0-9]{4}$/,
      phone: '',
      code: '',
      input_code_hinder: '请输入验证码',
      checked: false,
      centerDialogVisible: false,
      chanelId: 'M3H90001',
      toastDialogVisible: true,
      successMessage: '支付成功',
      toastImageSrc: require('@/assets/toast.png'),
      showToast: false,
      contentId: '',

      // chanelId: 'M3140070'
    }
  },
  created (): any {
    this.getContentIDFromURL()

  },
  methods: {
    getContentIDFromURL () {
      const urlParams = new URLSearchParams(window.location.search)
      this.contentId = urlParams.get('cpid') || ''
      console.log('Fetched contentID:', this.contentId)
    },

    handleCheckChanged () {
      if (!this.phone.trim()) {
        this.checked = false
        this.$message({
          message: '请填写手机号',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }
      return this.checked
    },
    readInfo () {
      this.centerDialogVisible = !this.centerDialogVisible
    },
    handColse () {
      this.showToast = false
    },
    getGo () {
      console.log('getGo')
      if (!this.checked) {
        return this.$message({
          message: '请阅读并同意《个人信息保护政策》',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }

      if (this.phone.length == 0) {
        return this.$message({
          message: '请输入手机号',
          type: 'warning',
          center: true,
          offset: window.screen.height / 2
        })
      }

      this.checkGo()
    },
    async checkGo () {
      this.createOder()

    },
    async createOder () {
      const loading = ElLoading.service({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      try {
        const response = await post<{
          code: string,
          msg: string,
          channel: string,
          miguOrderId: string,
          productId: string,
          misidn: string
        }>('/orderActivity', {
          mobile: this.phone,
          'cpid': this.contentId,
          province: '',
          channelCode:this.chanelId
        })
        console.log(response)

        if (response.code == 0) {
          if (response) {
            var payjson = {
              'orderId': response.data.miguOrderId,
              'channelCode': response.data.channel,
              'productId': response.data.productId,
              'misidn': response.data.misidn,
              'actionType': '1'
            }
            loading.close()
            window.MiguSdk.migupay(payjson, (resultCode, msg, data) => {
              console.log(data)
              console.log(resultCode)
              console.log(msg)
              if (resultCode.toString() == '0000' || resultCode.toString() == '4901') {
                // this.$message({
                //   message: '支付成功',
                //   type: 'success',
                //   center: true,
                //   offset: window.screen.height / 2
                // })
                this.showToast = true

              } else {
                loading.close()
                this.$message({
                  message: '支付失败',
                  type: 'error',
                  center: true,
                  offset: window.screen.height / 2
                })
              }
            })
          }
        } else {
          loading.close()
          this.$message({
            message: response.msg,
            type: 'error',
            center: true,
            offset: window.screen.height / 2
          })
        }
      } catch (error) {
        console.error(error)
        this.$message({
          message: error,
          type: 'error',
          center: true,
          offset: window.screen.height / 2
        })
      }

    }
  },
  async mounted () {
    const loading = ElLoading.service({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    try {
      const script = document.createElement('script')
      script.src = 'https://cdn3.cmread.com/opf-meta/upload/24/1115/10/55/51/241115105551442f116.js'
      // script.src = 'http://static.st.cmread.com:8117/comment/js/5539fae9a36ba9a70553a0054c04ea05d3588cb4718b/migusdk.js'
      script.onload = () => {
        console.log('MiguSdk loaded', window.MiguSdk)
        // 在此处调用 MiguSdk 的方法

        var json = {
          'channelCode': this.chanelId,
          /**渠道id，每个合作方独有的渠道id必填*/
          'sdkType': 'https',
          /**sdk加载类型，默认https，如注册的域名netid是http则填写http必填*/
          'domain': 'mgread.17xiudou.cn',
          /**当前域名，用来匹配netids中的netid必填*/
          'option': { /*option具体说明请看文档*/
            'umark': 'Common2',
            'color': ''
          }
        }
        window.MiguSdk.getData(json, (resultCode, msg, authSessionId) => {
          /**二次处理*/
          loading.close()
          console.log(resultCode.toString())
          if (resultCode.toString() !== '0000') {
            this.$message({
              message: '加载失败',
              type: 'error',
              center: true,
              offset: window.screen.height / 2
            })
          }
        })

      }
      document.head.appendChild(script)

    } catch (error) {
      console.error('Failed to load MiguSdk:', error)
    }

  }
})
export default class HomeView extends Vue {
}
</script>
<style scoped lang="scss">
.home {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background-color: #201207;
}

:deep(.home .el-main ) {
  padding: 0;
  margin: 0;
}

:deep(.home .el-container ) {
  padding: 0;
  margin: 0;
}

.el_col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el_row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el_phone_input {
  width: 80%;
  height: 70px;
  font-size: 24px;
}

:deep(.el_phone_input .el-input__wrapper) {
  border-radius: 30px;
}

.el_code_input {
  width: 60%;
  height: 70px;
  font-size: 24px;
  margin-top: 30px;
}

:deep(.el_code_input .el-input__wrapper) {
  border-radius: 30px 0 0 30px;
}

.img {
  width: 80%;
  margin-top: 30px;
}

.img_title {
  width: 100%;
}

.font_size {
  font-size: 20px;
  color: white;
  margin: 30px;
  text-align: left;
}

strong {
  font-size: 20px;
  color: rgba(246, 215, 6, 0.8);
}


</style>
